import PropTypes from 'prop-types';
import InputText from 'commons-forms/components/InputText/InputText.jsx';
import React from 'react';

import FIELD_LENGTH from 'commons-forms/constants/fieldLength.js';

const InputEmail = ({
    classNames,
    errorLabel,
    isDisabled,
    isRequired,
    isValid,
    hasBeenSubmit,
    label,
    value,
    onBlur,
    onFocus,
    valueChange,
    dataTest,
}) => {
    classNames.push('InputEmail');
    return (
        <InputText
            type="email"
            name="email"
            classNames={classNames}
            label={label}
            errorLabel={errorLabel}
            value={value}
            isRequired={isRequired}
            isValid={isValid}
            onBlur={onBlur}
            onFocus={onFocus}
            isDisabled={isDisabled}
            valueChange={(inputValue) => valueChange(inputValue, 'email')}
            hasBeenSubmit={hasBeenSubmit}
            dataTest={dataTest}
            maxLength={FIELD_LENGTH.EMAIL_MAX}
        />
    );
};

InputEmail.propTypes = {
    classNames: PropTypes.arrayOf(React.PropTypes.string),
    errorLabel: PropTypes.string,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    isValid: PropTypes.bool.isRequired,
    hasBeenSubmit: PropTypes.bool,
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    valueChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    dataTest: PropTypes.string,
};

InputEmail.defaultProps = {
    classNames: [],
    isDisabled: false,
    hasBeenSubmit: false,
    errorLabel: '',
    isRequired: false,
    onBlur: () => {},
    value: '',
    dataTest: '',
};

InputEmail.displayName = 'InputEmail';

export default InputEmail;



// WEBPACK FOOTER //
// ./src/components/InputEmail/InputEmail.jsx